var map = {
	"./01.png": 1920,
	"./02.png": 1921,
	"./03.png": 1922,
	"./04.png": 1923,
	"./05.png": 1924,
	"./06.png": 1925,
	"./banner.png": 1926,
	"./default.jpg": 439,
	"./fengjing.png": 1927,
	"./jiaotong.png": 1928,
	"./map.png": 1929,
	"./tongzhi.png": 1930
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 745;


//////////////////
// WEBPACK FOOTER
// ../assets/images/index ^\.\/.*$
// module id = 745
// module chunks = 0